import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row codes-item" }
const _hoisted_2 = { class: "col codes-item-description content-center" }

import {CodesItemDataModel} from 'components/resources/CodesItemData.model';
  import { useGrouperStore } from 'stores/grouper-store';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CodesItem',
  props: {
    codesItemDataModel: {}
  },
  setup(__props: any) {

  const grouperStore = useGrouperStore();
  const props = __props;

  function addCode(code: string, codeType: string, shortDescription: string) {
    if (codeType.endsWith('_DX') || codeType.endsWith('_E')) {
      grouperStore.addDiagnosisCode(code, shortDescription, undefined);
    } else {
      grouperStore.addProcedureCode(code, shortDescription);
    }
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addCode(props.codesItemDataModel.value, props.codesItemDataModel.codeType, props.codesItemDataModel.shortDescription))),
      class: "codes-item-code iodine-padding-right-md content-center"
    }, _toDisplayString(props.codesItemDataModel.value), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.codesItemDataModel.mediumDescription), 1)
  ]))
}
}

})